module.exports = __webpack_public_path__ + "static/media/imgHome-min.ebb37785.webp";